import React from 'react';

// Styles & Assets
import styles from './Spinner.module.css';

// Spinner: Creates a loading spinner. Props received: 
//  -color: optional prop that receives a string with the
//  color of the spinner. By default the spinner is green.
const Spinner: React.FC<{
    color?: string,
    fit?: boolean,
    size?: number,
}> = ({ color, fit, size }) => {

    const colorSpinner = color + ' transparent transparent transparent';
    const stylesLoader = { 
        borderColor: colorSpinner, 
        height: size ? (size - size / 5)+'px' : undefined,
        width: size ? (size - size / 5)+'px' : undefined, 
        borderWidth: size ? (size / 10)+'px' : undefined,
        margin: size ? (size / 10)+'px' : undefined,
    };

    const SpinnerElement = (
        <div 
            className={styles.spinnerLoader}
            data-testid='spinner-loader'
            style={{height: size+'px', width: size+'px'}}
        >
            <div style={stylesLoader}></div>
            <div style={stylesLoader}></div>
            <div style={stylesLoader}></div>
            <div style={stylesLoader}></div>
        </div>
    );

    return (
        <>
            {fit ?
                SpinnerElement
                :
                <div className={styles.spinnerContainer} data-testid='spinnerContainer'>
                    {SpinnerElement}
                </div>
            }
        </>
    );
};

export default Spinner;